<template>
  <div>
    <el-dialog v-dialogDrag
      top="18vh"
      class="directive_dialog"
      :close-on-click-modal="false"
      custom-class="workStateDialog"
      :visible.sync="isDialogVisible"
      v-if="isDialogVisible"
      :before-close="beforeCloseHandle"
    >
      <!-- 开启工作提示弹窗 -->
      <img class="workImg" :src="workStateImg" width="250" height="185" />
      <p class="workText">{{ workStateText }}</p>
      <div class="workBtn" v-show="dialogInt == 0">
        <button :disabled="isDisabled" type="button" class="btn btn-blue" @click="openWorkHandle">
          开启工作
        </button>
      </div>
      <div class="workBtn" v-show="dialogInt == 1">
        <button
          type="button"
          :disabled="isDisabled"
          class="btn btn-linear-green"
          @click="restWorkHandle">
          休息
        </button>
        <button type="button" :disabled="isDisabled" class="btn btn-green" @click="suspWorkHandle">
          暂停
        </button>
      </div>
      <div class="workBtn" v-show="dialogInt == 2">
        <button
          type="button"
          :disabled="isDisabled"
          class="btn btn-linear-blue"
          @click="restWorkHandle">
          休息
        </button>
        <button type="button" :disabled="isDisabled" class="btn btn-blue" @click="openWorkHandle">
          开启
        </button>
      </div>
      <div class="workBtn" v-show="dialogInt == 3">
        <button
          type="button"
          :disabled="isDisabled"
          class="btn btn-linear-green"
          @click="openWorkHandle"
        >
          继续工作
        </button>
        <!-- <button type="button" class="btn btn-green" @click="endWorkHandle">
          下班
        </button> -->
      </div>
    </el-dialog>

    <!-- 工作状态右侧浮层 -->
    <div
      class="workStateRight"
      ref="workstate_bar"
      v-show="isShowWorkStateBar"
      @mousedown.prevent="mousedownHandle($event)"
    >
      <!-- 未开启 -->
      <div v-show="workStateInt == 0">
        <span class="workTextRight-green">未开启</span>
        <button
          type="button"
          class="btn btn-green-circle"
          @click.stop="openDialog($event)"
        >
          开启<br />工作
        </button>
      </div>

      <!-- 工作中 -->
      <div v-show="workStateInt == 1">
        <span class="workTextRight-blue">工作中…</span>
        <button
          type="button"
          class="btn btn-blue-circle"
          @click.stop="openDialog($event), suspHandle()"
        >
          <span v-if="roleId === 91">暂停<br />接单</span>
          <span v-else>暂停<br />工作</span>
        </button>
      </div>

      <!-- 暂停接单中 -->
      <div v-show="workStateInt == 2">
        <span class="workTextRight-green">暂接中…</span>
        <button
          type="button"
          class="btn btn-green-circle"
          @click.stop="openDialog($event), openHandle()"
        >
          <span v-if="roleId === 91">开始<br />接单</span>
          <span v-else>开始<br />工作</span>
        </button>
      </div>

      <!-- 休息中 -->
      <div v-show="workStateInt == 3">
        <span class="workTextRight-green">休息中…</span>
        <button
          type="button"
          class="btn btn-green-circle"
          @click.stop="openDialog($event), openHandle2()"
        >
          开启<br />工作
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdminWorkState, addWorkState } from 'network/workstate.js';
import { isEditorNull } from '../common/utils';
export default {
  name: 'WorkstateSwitch',
  props: {
    workState: {
      type: Number,
      default: null
    },
    ready:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      isDialogVisible: false,
      dialogInt: 0, // 提示弹层: 0开启工作提示 1暂停接单提示 2开启接单提示 3休息提示
      isShowWorkStateBar: false,
      workStateInt: window.sessionStorage.getItem('workStateInt') || 0, // 工作状态: 0未开始工作 1工作中 2暂停中 3休息中
      timer: null, //下班倒计时
      afterWorkTime: '17:30', // 下班时间, 如17:30
      startData: {
        x: 0,
        y: 0, //移动元素事件中鼠标按下的位置
      },
      queryAdminId:null,
      isDisabled: false,
      isInitialized:false,
    };
  },
  computed: {
    workStateImg() {
      const num = this.dialogInt;
      if (num == 0 || num == 2) {
        return require('../assets/images/workingstate01.jpg');
      }
      if (num == 1 || num == 3) {
        return require('../assets/images/workingstate02.jpg');
      }
    },
    workStateText() {
      const num = this.dialogInt;
      let roleId = this.roleId;
      if (num == 0) {
        if (roleId === 91) {
          return '新的一天开始啦，系统将开始为你分配名单';
        } else {
          return '新的一天开始啦';
        }
      }
      if (num == 1) {
        if (roleId === 91) {
          return '“暂停接单”状态时，系统将不会为你分配名单';
        } else {
          return '暂停工作';
        }
      }
      if (num == 2) {
        if (roleId === 91) {
          return '“接单中”状态时，系统将继续为你分配名单';
        } else {
          return '开始工作';
        }
      }
      if (num == 3) {
        if (roleId === 91) {
          return '当前为休息状态，系统不会为你分配名单。如需继续接收名单，请点击“继续工作”';
        } else {
          return '已进入休息状态。如需继续工作，请点击“继续工作”';
        }
      }
      consol.log(num);
    },
    // 当前登录用户id
    memberId() {
     if (this.$store.state&&this.$store.state.AdminCache&&this.$store.state.AdminCache.adminId) {
        return this.$store.state.AdminCache.adminId;
      } else if (sessionStorage.getItem("AdminCache")) {
        return JSON.parse(sessionStorage.getItem("AdminCache")).adminId;
      } else {
        return this.queryAdminId;
      }
    },
    // 当前登录用户名称
    roleId() {
      return this.$store.state.AdminCache.rolesId;
    },
  },
  watch: {
    //监听路由是否有管理员id
    "$route.query.adminId": {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.queryAdminId = newVal;
        }
      },
      deep: true,
    },
    "workState":{
      handler(newVal) {
        this.workStateInt = newVal
        
      },
    },
    ready: {
      handler(val) {
        if (val && !this.isInitialized) {
          this.isInitialized = true;
          this.getAdminWorkStateData();
        }
      },
      immediate: true,
        
    },
  },
  mounted() {

    // 如果 ready 为 true 且未初始化，立即执行
    if (this.ready && !this.isInitialized) {
      this.getAdminWorkStateData()
    }

  },
  methods: {
    getAdminWorkStateData(){
      const that = this;
      // 获取当前用户工作状态
      getAdminWorkState()
        .then((res) => {
          if (res && res.code == 1) {
            that.$emit('permission', true);
            that.workStateInt = res.result.state;
            // 刷新页面操作时，不重复打开 开启工作提示 弹窗
            const workStateInt = that.workStateInt;
            if (workStateInt == 1 || workStateInt == 2 || workStateInt == 3) {
              that.isShowWorkStateBar = true;
            } else {
              that.isDialogVisible = true;
            }
          } else {
            that.$emit('permission', false);
          }
        })
        .catch((err) => {
          that.$emit('permission', false);
        });
    },
    changeWorkState(type){
      this.workStateInt = type
    },
    // 开启工作
    openWorkHandle() {
      this.workStateInt = 1;
      this.submitWorkState();
    },
    // 确定暂停
    suspWorkHandle() {
      this.workStateInt = 2;
      this.submitWorkState();
    },
    // 确定休息
    restWorkHandle() {
      this.workStateInt = 3;
      this.submitWorkState();
    },
    // 确定下班
    // endWorkHandle() {
    //   this.workStateInt = 0;
    //   this.submitWorkState();
    // },
    // 打开弹窗
    openDialog(event) {
      // 当事件为拖曳移动元素时，阻止执行其他点击事件
      if (
        event.clientX != this.startData.x ||
        event.clientY != this.startData.y
      ) {
        return false;
      }
      this.isShowWorkStateBar = false;
      this.isDialogVisible = true;
    },
    // 暂停接单
    suspHandle() {
      this.dialogInt = 1;
    },
    // 开启接单
    openHandle() {
      this.dialogInt = 2;
    },
    // 开启工作2
    openHandle2() {
      this.dialogInt = 3;
    },
    // 点击关闭按钮
    beforeCloseHandle(done) {
      this.isShowWorkStateBar = true;
      done(); // 关闭dialog
    },
    // 提交工作状态
    async submitWorkState() {
      this.isDisabled = true
      const workStateInt = this.workStateInt;
      const obj = {
        state: workStateInt,
        memberId: this.memberId,
      };
      // const res = await addWorkState(obj);
      // if (res && res.code == 1) {
      //   return true;
      // }
      // if (res && res.code == 0) {
      //   this.$message.error(res.message);
      // }
      const that = this;
      addWorkState(obj)
        .then((res) => {
          if (res && res.code == 1) {
            window.sessionStorage.setItem('workStateInt', workStateInt);
            that.isDialogVisible = false;
            this.isDisabled = false
            that.isShowWorkStateBar = true;
          } else {
            this.isDisabled = false
            that.$alert(res.message);
          }
        })
        .catch((err) => {
          this.isDisabled = false
          that.$alert('工作状态切换失败，请稍后再试！');
        });
    },
    // 鼠标按下
    mousedownHandle(event) {
      const bar = this.$refs.workstate_bar;
      //获取按下的位置
      const x = event.clientX;
      const y = event.clientY;
      // 记录鼠标按下时位置
      this.startData.x = x;
      this.startData.y = y;
      // 获得鼠标按下时元素的right、bottom值
      var moveElX = bar.offsetLeft;
      var moveElY = bar.offsetTop;
      // 最大边界
      var bodywith =
        document.body.clientWidth || document.documentElement.clientWidth; //网页可见区域宽(body)
      var bodyheight =
        document.body.clientHeight || document.documentElement.clientHeight; //网页可见区域高(body)
      var moveElWidth = bar.offsetWidth;
      var moveElHeight = bar.offsetHeight;
      var maxDisX = bodywith - moveElWidth;
      var maxDisY = bodyheight - moveElHeight;
      // 鼠标移动：动态修改移动元素的left、top属性
      document.onmousemove = function(event) {
        let nowLeft = event.clientX - x + moveElX;
        let nowTop = event.clientY - y + moveElY;
        if (nowLeft <= 0) {
          nowLeft = 0;
        }
        if (nowLeft >= maxDisX) {
          nowLeft = maxDisX;
        }
        if (nowTop <= 0) {
          nowTop = 0;
        }
        if (nowTop >= maxDisY) {
          nowTop = maxDisY;
        }
        bar.style.left = nowLeft + 'px';
        bar.style.top = nowTop + 'px';
      };
      document.onmouseup = function(event) {
        document.onmousemove = null;
      };
    },
    // 下班倒计时事件（功能暂不需要）
    afterWorkCountdown() {
      let afterWorkTime = this.afterWorkTime;
      if (!afterWorkTime) {
        return false;
      }
      let afterWorkTimeArray = afterWorkTime.split(':');
      const nowTimeH = new Date().getHours();
      const nowTimeM = new Date().getMinutes();
      if (
        afterWorkTimeArray[0] <= nowTimeH &&
        afterWorkTimeArray[1] <= nowTimeM
      ) {
        return false;
      }
      const that = this;
      that.timer = setInterval(function() {
        const nowH = new Date().getHours();
        const nowM = new Date().getMinutes();
        if (afterWorkTimeArray[0] <= nowH && afterWorkTimeArray[1] <= nowM) {
          that.dialogInt = 3;
          that.isDialogVisible = true;
          that.isShowWorkStateBar = false;
          clearInterval(that.timer);
          that.timer = null;
        }
      }, 5000);
    },
  },
};
</script>

<style scoped>
/deep/ .workStateDialog {
  border-radius: 16px;
  text-align: center;
  width: 368px;
}
.workImg {
  width: 250px;
  height: auto;
}
.workText {
  font-size: 14px;
  color: #5f7285;
  margin-top: 15px;
}
.workBtn {
  margin-top: 30px;
}
.workBtn .btn {
  width: 120px;
  height: 40px;
  font-size: 16px;
  outline: none;
  border-radius: 6px;
  border: 1px solid #4d93d5;
  margin: 0 10px;
}
.workBtn .btn:hover {
  opacity: 0.8;
}
.workBtn .btn-blue {
  background-color: #4d93d5;
  color: #fff;
}
.workBtn .btn-linear-blue {
  background-color: #eef7ff;
  color: #4d93d5;
}
.workBtn .btn-green {
  background-color: #60c6c8;
  color: #fff;
  border-color: #60c6c8;
}
.workBtn .btn-linear-green {
  background-color: #effdfd;
  color: #60c6c8;
  border-color: #60c6c8;
}

.workStateRight {
  width: 178px;
  height: 64px;
  padding: 12px;
  position: fixed;
  z-index: 99999;
  right: -72px;
  bottom: 12px;
  transition-duration: 0.15s;
  -webkit-transition-duration: 0.15s;
  -o-transition-duration: 0.15s;
  -ms-transition-duration: 0.15s;
}
.workStateRight:hover {
  right: 4px;
  transition-duration: 0.15s;
  -webkit-transition-duration: 0.15s;
  -o-transition-duration: 0.15s;
  -ms-transition-duration: 0.15s;
}
.workTextRight-blue,
.workTextRight-green {
  background-color: #eef7ff;
  height: 40px;
  line-height: 36px;
  border-radius: 60px;
  display: inline-block;
  padding-left: 15px;
  padding-right: 64px;
  font-weight: bold;
  font-size: 16px;
  box-sizing: border-box;
  box-shadow: 0 0 10px rgba(77, 147, 213, 0.75);
  -webkit-box-shadow: 0 0 10px rgba(77, 147, 213, 0.75);
  cursor: move;
}
.workTextRight-blue {
  border: 2px solid #4d93d5;
  color: #4d93d5;
}
.workTextRight-green {
  border: 2px solid #60c6ca;
  color: #60c6ca;
}
.btn-blue-circle,
.btn-green-circle {
  border-radius: 50%;
  width: 68px;
  height: 68px;
  border: 3px solid #fff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  position: absolute;
  right: 0px;
  top: 50%;
  margin-top: -34px;
  box-shadow: 0 0 10px rgba(77, 147, 213, 0.75);
  -webkit-box-shadow: 0 0 10px rgba(49, 62, 75, 0.75);
}
.btn-blue-circle {
  background-color: #4d93d5;
}
.btn-blue-circle:hover {
  color: #fff;
  background-color: #63a4e8;
}
.btn-green-circle {
  background-color: #60c6ca;
}
.btn-green-circle:hover {
  color: #fff;
  background-color: #71dfde;
}
button[disabled] {
  cursor: not-allowed;
  opacity: 0.7;
}
</style>
